export default "__VITE_ASSET__u_NmVJl5__"